import { OCR_LIMITS } from '../../core/config.js';

const EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'webp', 'avif', 'heic', 'heif', 'tif', 'tiff', 'bmp', 'gif', 'svg', 'pdf']);

const MIME_EXTENSIONS = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/avif': 'avif',
  'image/heic': 'heic',
  'image/heif': 'heif',
  'image/tiff': 'tiff',
  'image/bmp': 'bmp',
  'image/gif': 'gif',
  'image/svg+xml': 'svg'
};

export function clipboardImageFiles(clipboardData, timestamp = Date.now()) {
  const itemFiles = Array.from(clipboardData?.items || [])
    .filter(item => item.kind === 'file')
    .map((item, index) => {
      const blob = item.getAsFile();
      const mime = blob?.type || item.type;
      if (!blob || !mime.startsWith('image/')) return null;
      const extension = MIME_EXTENSIONS[mime] || 'png';
      const hasSupportedExtension = EXTENSIONS.has(blob.name?.split('.').pop()?.toLowerCase());
      if (hasSupportedExtension) return blob;
      return new File([blob], `image-collee-${timestamp}-${index + 1}.${extension}`, {
        type: mime,
        lastModified: timestamp
      });
    })
    .filter(Boolean);
  if (itemFiles.length) return itemFiles;
  return Array.from(clipboardData?.files || []).filter(file => file.type.startsWith('image/'));
}

export function validateFiles(fileList) {
  const files = Array.from(fileList || []);
  if (!files.length) return ['Choisissez au moins un fichier.'];
  const errors = [];
  if (files.length > OCR_LIMITS.maxFiles) errors.push(`Maximum ${OCR_LIMITS.maxFiles} fichiers.`);
  const total = files.reduce((sum, file) => sum + file.size, 0);
  if (total > OCR_LIMITS.maxRequestBytes) errors.push('La sélection dépasse 80 MiB.');
  for (const file of files) {
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!EXTENSIONS.has(extension)) errors.push(`${file.name}: format non pris en charge.`);
    if (file.size > OCR_LIMITS.maxFileBytes) errors.push(`${file.name}: dépasse 20 MiB.`);
    if (!file.size) errors.push(`${file.name}: fichier vide.`);
  }
  return [...new Set(errors)];
}

export function validatePublicUrl(value) {
  try {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol)) return 'Utilisez une URL HTTP ou HTTPS.';
    if (url.username || url.password) return 'Les URLs contenant des identifiants sont refusées.';
    return '';
  } catch {
    return 'Saisissez une URL valide.';
  }
}
